class AjaxCart extends HTMLElement {
      constructor() {
        super();
        const self = this;
        this.cartDrawer = this.querySelector('cart-drawer');
        this.cartIcon = document.getElementById("cart-icon-bubble");
        this.cartIcon.addEventListener('click', this.toggle.bind(this));
        this.cartMobile = document.querySelector(".header-cart-mobile");
        this.cartMobile.addEventListener('click', function(event){
          event.preventDefault();
          self.toggle(event)
        })
        this.bindEvents();
      }

      bindEvents() {
        this.cartClose = this.querySelector('.cart__close');
        this.cartClose.addEventListener('click', this.close.bind(this));
        this.backdrop = this.querySelector('backdrop');
        this.backdrop.addEventListener('click', this.close.bind(this));
        this.swipeMove();
        this.emptyState = this.querySelector('.ajax-is-empty .cart__close');
        this.emptyState.addEventListener('click', this.close.bind(this));
      }

      swipeMove() {
        let startX, startY, distX, distY
        this.querySelector('cart-drawer').addEventListener('touchstart', (e) => {

            if (e.target.closest('component-product-bundle-slider')) {
                return null
            }

          var touchobj = e.changedTouches[0];
          startX = touchobj.pageX
          startY = touchobj.pageY
        });
        this.querySelector('cart-drawer').addEventListener('touchend', (e) => {

            if (e.target.closest('component-product-bundle-slider')) {
                return null
            }

            var touchobj = e.changedTouches[0];
          distX = touchobj.pageX - startX
          distY = touchobj.pageY - startY;
          if(distX > 80) {
            e.preventDefault();
            this.close();
          }
        });
      }

      toggle(event) {
        event.preventDefault();
        event.stopPropagation();
        return this.hasAttribute("open") ? this.close() : this.open();
      }

      open(event) {
        var html = document.getElementsByTagName( 'html' )[0];
        this.cartDrawer.classList.add('animate', 'active');
        this.setAttribute("open", "");
        document.body.classList.add(`ajax-cart-open`);
        html.classList.add('ajax-is-open');
      }

      headerClose(event) {
        if(document.body.classList.contains(`ajax-cart-open`)) {
          event.stopPropagation();
          event.preventDefault();
          this.close();
        }
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      close() {
        this.removeAttribute("open", "");
        var html = document.getElementsByTagName( 'html' )[0];
        html.classList.remove('ajax-is-open');
        document.body.classList.remove(`ajax-cart-open`);
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden-tablet');
      }

      // Only needed if wishlist present
      initializeWishlistButtons() {
        if("_swat" in window) {  _swat.initializeActionButtons("#shopify-section-ajax-cart") }
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section => {
          var section = document.getElementById(section.id);
          if(section) section.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
        setTimeout(() => {
          this.initializeWishlistButtons();
          this.open();
        }, 100);
        this.bindEvents();
      }

      getSectionsToRender() {
        return [
          {
            id: 'ajax-cart',
            selector: `#ajax-cart`,
          },
          {
            id: 'gift-with-purchase',
            selector: '#gift-with-purchase'
          }
        ];
      }
    }
customElements.define('ajax-cart', AjaxCart);

// var closeCart = document.querySelector('.ajax-is-empty .cart__close');
// if(closeCart){
//   var ajaxCart = document.querySelector('ajax-cart');
//   console.log(ajaxCart)
//   closeCart.addEventListener('click', function(){
//     ajaxCart.removeAttribute('open', '');
//     var html = document.getElementsByTagName( 'html' )[0];
//     html.classList.remove('ajax-is-open');
//     document.body.classList.remove(`ajax-cart-open`);
//     document.body.classList.remove('overflow-hidden');
//     document.body.classList.remove('overflow-hidden-tablet');
//   });
// }
